/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The ESPSettingsAccess model module.
 * @module model/ESPSettingsAccess
 * @version 1.0.0
 */
export class ESPSettingsAccess {
  /**
   * Constructs a new <code>ESPSettingsAccess</code>.
   * @alias module:model/ESPSettingsAccess
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ESPSettingsAccess</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ESPSettingsAccess} obj Optional instance to populate.
   * @return {module:model/ESPSettingsAccess} The populated <code>ESPSettingsAccess</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ESPSettingsAccess();
      if (data.hasOwnProperty('user'))
        obj.user = ApiClient.convertToType(data['user'], 'String');
      if (data.hasOwnProperty('pass'))
        obj.pass = ApiClient.convertToType(data['pass'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} user
 */
ESPSettingsAccess.prototype.user = undefined;

/**
 * @member {String} pass
 */
ESPSettingsAccess.prototype.pass = undefined;

